import { localize } from 'helpers/translator'
import { createSelector } from 'reselect'
import activePairSelector from './creation_tool_active_pair_selector'

export default createSelector(
	[activePairSelector],
	activePair => {
		const pairStatus = {
			card1: {
				valid: true,
			},
			card2: {
				valid: true,
			},
			message: '',
		}
		if (activePair.card1.value === null || activePair.card1.value === '') {
			pairStatus.card1.valid = false
			pairStatus.message = localize('matching_pairs_ct_complete')
		}
		if (activePair.card2.value === null || activePair.card2.value === '') {
			pairStatus.card2.valid = false
			pairStatus.message = localize('matching_pairs_ct_complete')
		}
		return pairStatus
	}
)
